const styles = theme => {
  return {
    root: {
      width: '320px',
      borderRadius: '0',
      height: '135px',
      fontSize: '20px',
      margin: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        width: '270px'
      },
      '&:hover': { filter: 'brightness(0.98)' }
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 'bold',
      marginRight: '20px',
      alignItems: 'flex-end'
    },
    counter: { fontSize: '46px' },
    labelSmall: { fontSize: '16px' },
    label: {
      marginRight: '20px',
      fontWeight: 'bold',
      textAlign: 'end'
    },
    text: {
      fontSize: '14px',
      marginTop: '5px'
    },
    icon: {
      fontSize: '48px',
      paddingLeft: '20px'
    }
  };
};

export default styles;
